<template>
  <time>
    {{ time.hours() }}h {{ time.minutes(true) }}min {{ time.seconds() }}sec
  </time>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    value: {
      type: Date,
      required: true
    }
  },
  data () {
    return {
      interval: null,
      now: new Date()
    }
  },
  computed: {
    time () {
      const diff = this.value - this.now
      if (diff <= 0) {
        this.$emit('finish')
      }
      return moment.duration(diff)
    }
  },
  mounted () {
    this.$set(this, 'interval', setInterval(() => {
      this.$set(this, 'now', new Date())
    }, 1000))
  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Timer.vue